export interface TodayLoadsDTO {
  SHP: number;
  expectedToBeSHP: number;
}

export const todayLoadsDTOMapper = (data: any): TodayLoadsDTO => ({
  SHP: data?.todayLoads?.SHP || 0,
  expectedToBeSHP: data?.todayLoads?.expectedToBeSHP || 0
});
